import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { mergeMap } from 'rxjs/operators';

import { DevicesService } from '@era/locations-sdk';
import { safeMap } from '@era/stores';
import {
  DeviceAssignmentHistoryApiActions,
  DeviceAssignmentHistoryResolverActions,
} from './device-assignment-history.actions';

@Injectable()
export class DeviceAssignmentHistoryEffects {
  private readonly deviceService = inject(DevicesService);
  private readonly actions$ = inject(Actions);

  deviceAssignmentHistoryRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceAssignmentHistoryResolverActions.historyRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.deviceService.getDeviceAssignmentHistory({ udid }),
          (history) => DeviceAssignmentHistoryApiActions.historyLoaded({ history, udid }),
          (error) => DeviceAssignmentHistoryApiActions.historyLoadedError({ error })
        )
      )
    );
  });
}
